<!-- <form method="POST" enctype="multipart/form-data"> -->
    <div class="form-group">
        <div class="input-field">
            {{ file }}
        </div>
        <div class="upload-btn-wrapper">
            <a nbButton class="btn">
                <nb-icon icon="cloud-upload"></nb-icon>
                &nbsp;Choose file</a>
            <input type="file" [name]="inputname" (input)="handleChange($event)"/>
          </div>
    </div>
